<div
  *ngIf="_$ | async as _"
  #dropdown
  ngbDropdown
  container="body"
  placement="top-left"
  class="lum-meta-menu-item-group__inner lum-c-user-profile"
>
  <button
    ngbDropdownToggle
    class="lum-meta-menu-item"
    [attr.data-offset]="'10px,0px'"
  >
    <icon name="user-circle" class="lum-meta-menu-item__icon" [size]="24"></icon>

    <span class="lum-meta-menu-item__text">
      <span class="sr-only">Logged in as</span>
      {{ _.user.firstname + ' ' + _.user.lastname }}
      <span class="sr-only">(click to manage user settings)</span>
    </span>

    <small
      *ngIf="_.showBadge"
      [class]="
        '  lum-meta-menu-item__badge lum-meta-menu-item__badge--circular' +
        '  lum-meta-menu-item__badge--' +
        _.severity +
        '  lum-c-user-profile__toggle-badge'
      "
      role="presentation"
    >
      {{ _.status === AccountStatus.TRIAL ? '' : '!' }}
    </small>
  </button>
  <div
    ngbDropdownMenu
    class="
      dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl lum-c-user-profile__menu
    "
  >
    <!--begin: Head -->
    <div
      class="
        kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x lum-c-user-profile__menu-header
      "
      style="background-image: url(./assets/media/misc/bg-1.jpg)"
    >
      <div class="kt-user-card__avatar">
        <span
          [hidden]="true"
          class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold"
        >
          {{ _.user.firstname + ' ' + _.user.lastname | firstLetter }}
        </span>
      </div>
      <div class="kt-user-card__name">
        <div>
          {{ _.user.firstname + ' ' + _.user.lastname }}
        </div>
        <div class="lum-c-user-profile__company-name">
          {{ _.companyName }}
        </div>
      </div>
      <div></div>
      <div class="kt-user-card__toggle-badge"></div>
    </div>
    <!--end: Head -->

    <!--begin: Account Status Message -->
    <div
      *ngIf="_.showMessage"
      class="kt-notification lum-c-user-profile__menu-section"
    >
      <div
        [ngSwitch]="_.status"
        [class]="
          ' kt-notification__custom' +
          ' lum-c-user-profile__status-message lum-c-user-profile__status-message--' +
          _.severity
        "
      >
        <p class="mb-0" *ngSwitchCase="AccountStatus.CANCELLED">
          <strong>This account is no longer active.</strong>
          If you believe there's been a mistake, contact Luminous support and we'll
          get everything cleared up.
        </p>
        <p class="mb-0" *ngSwitchCase="AccountStatus.DEMO">
          <em>This account is in Demo mode.</em>
        </p>
        <p class="mb-0" *ngSwitchCase="AccountStatus.PAST_DUE">
          <strong>Uh-oh! It looks like your account is past-due.</strong>
          Contact a Luminous Account Representative right away so that we can ensure
          your data is retained and you can enjoy all the latest features.
        </p>
        <p class="mb-0" *ngSwitchCase="AccountStatus.TRIAL">
          <strong>You are currently enjoying a trial version of Luminous.</strong>
          Contact one of our Sales or Account Representatives to upgrade today to
          ensure your data is retained and you have access to all the latest
          features of Luminous!
        </p>
      </div>
    </div>
    <!--end: Head -->

    <!--begin: Navigation -->
    <nav class="kt-notification lum-c-user-profile__menu-items">
      <a
        (click)="goTo('/settings/app-integration-account-settings')"
        [routerLink]="['/settings/app-integration-account-settings']"
        routerLinkActive="router-link-active"
        class="kt-notification__item lum-c-user-profile__menu-item"
        ngbDropdownToggle
      >
        <div class="kt-notification__item-icon">
          <i class="fas fa-stream"></i>
        </div>
        <div class="kt-notification__item-details">
          <div class="kt-notification__item-title kt-font-bold"> Integrations </div>
        </div>
      </a>

      <a
        (click)="openProfile()"
        href="javascript:;"
        class="kt-notification__item lum-c-user-profile__menu-item"
      >
        <div class="kt-notification__item-icon">
          <i class="flaticon2-calendar-3"></i>
        </div>
        <div class="kt-notification__item-details">
          <div
            class="kt-notification__item-title kt-font-bold"
            [translate]="'GENERAL.MY_PROFILE'"
          >
            My Profile
          </div>
          <div
            class="kt-notification__item-time"
            [translate]="'GENERAL.MY_PROFILE_DESC'"
          >
            Account settings
          </div>
        </div>
      </a>

      <a
        (click)="changePasswd()"
        href="javascript:;"
        class="kt-notification__item lum-c-user-profile__menu-item"
      >
        <div class="kt-notification__item-icon">
          <i class="flaticon2-lock"></i>
        </div>
        <div class="kt-notification__item-details">
          <div
            class="kt-notification__item-title kt-font-bold"
            [translate]="'GENERAL.CHANGE_PASSWORD'"
          >
            Change Password
          </div>
        </div>
      </a>

      <a
        (click)="goTo('/settings/system')"
        [routerLink]="['/settings/system']"
        routerLinkActive="router-link-active"
        class="kt-notification__item lum-c-user-profile__menu-item"
        *ngIf="_.user.is_admin == 1"
        ngbDropdownToggle
      >
        <div class="kt-notification__item-icon">
          <i class="fas fa-cogs"></i>
        </div>
        <div class="kt-notification__item-details">
          <div
            class="kt-notification__item-title kt-font-bold"
            [translate]="'SETTINGS.TITLE'"
          >
            System Settings
          </div>
        </div>
      </a>
      <div class="kt-notification__custom">
        <a
          href="javascript:;"
          (click)="logout()"
          class="btn btn-label-brand btn-sm btn-bold"
          [translate]="'AUTH.GENERAL.SIGN_OUT'"
        >
          Sign Out</a
        >
      </div>
    </nav>
    <!--end: Navigation -->
  </div>
</div>
